<template>
<div class="chapter">
<div class="inner_page">
<div>
<br/>
<br/>
<br/>
<p class="ded1"><b>A<span class="small">LSO FROM</span> A<span class="small">KASHI</span>C<span class="small">LASSICS</span>: R<span class="small">ENEGADE</span> R<span class="small">EPRINT</span> S<span class="small">ERIES</span></b></p>
<p class="ser"><i>Home: Social Essays</i></p>
<p class="ser1">by LeRoi Jones (Amiri Baraka)</p>
<p class="ser"><i>The Hungered One</i></p>
<p class="ser">short stories by Ed Bullins</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c7.vue?7b116455